import React, { useContext, useEffect } from 'react';
import Link from 'next/link';
import { StorefrontContext } from 'providers/storefront';
import { handleResetSearch } from 'helpers/searchReset';
import styles from './styles';

const KnowledgeHubBreadcrumbs = ({ topic, postPage, post, discussions }) => {
  const {
    setFilteredResults,
    setSearchInput,
    selectedDiscussion,
    setSelectedDiscussion,
  } = useContext(StorefrontContext);

  useEffect(() => {
    const postsDiscussion = post?.data?.discussions_group[0]?.discussion_link.uid;
    if (
      post &&
      selectedDiscussion?.type !== 'discussion' &&
      selectedDiscussion?.uid !== postsDiscussion
    ) {
      const discussion = discussions.find(
        (dics) => dics.uid === postsDiscussion,
      );
      setSelectedDiscussion(discussion);
    }
  }, []);
  return (
    <>
      <div
        className="breadcrumbs-container"
        onClick={() => handleResetSearch(setFilteredResults, setSearchInput)}
      >
        <Link href="/knowledge-hub" className="breadcrumbs-title">
          <a className="overflow-hidden">Knowledge Hub</a>
        </Link>
        <span className="breadcrumbs-title">
          <img draggable="false" src="/icons/Arrow.png" alt="chevron-right" />
        </span>
        {postPage ? (
          <Link
            href={`/knowledge-hub/${topic.uid}`}
            className="breadcrumbs-title"
          >
            <a className={'overflow-hidden ' + (!postPage && 'active-link')}>
              {topic.data.topic_title}
            </a>
          </Link>
        ) : (
          <span className="active-link">{topic.data?.topic_title}</span>
        )}
        {postPage && (
          <>
            <span className="breadcrumbs-title">
              <img
                draggable="false"
                src="/icons/Arrow.png"
                alt="chevron-right"
              />
            </span>
            <span className="active-link overflow-hidden">
              {selectedDiscussion?.data.discussion_title}
            </span>
          </>
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default KnowledgeHubBreadcrumbs;
